export const environment = {
  production: true,
  // baseURL: 'http://localhost:1337/v1/api',
  baseURL: 'https://whatsapp.tendertruck.in/v1/api',
};
